module.exports = __webpack_public_path__ + "img/blue_173.9b37ae15.png";